'use client';

import useModal from '@/hooks/useModal';
import { FC } from 'react';
import styles from '../FormFooter.module.scss';

interface Props {
  name: string;
  label: string;
}

const OpenModalWrapper: FC<Props> = ({ name, label }) => {
  const { openModal } = useModal();

  return (
    <span className={styles.link} onClick={() => openModal({ name })}>
      {label}
    </span>
  );
};

export default OpenModalWrapper;
